// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/enroll.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/enroll-patients.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/account-patients.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/but_xolair.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzY1MDU1NCIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiM4NTBkNzAiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/cta_box_purple.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/messages-close-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/desc.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
@font-face {
    font-family: "CongressSansStd";
    /*src: url('../fonts/241041_B_0.eot');*/
    src:/*url('../fonts/241041_B_0.eot?#iefix')*/ format("embedded-opentype"), /*url('../fonts/241041_B_0.woff')*/ format("woff"),
        /*url('../fonts/241041_B_0.ttf')*/ format("truetype");
    font-weight: normal;
    font-style: normal;
}

body {
}
.file2 {
    display: none;
}
/*all pages*/
.clearfloat {
    clear: both;
    height: 0;
    font-size: 1px;
    line-height: 0px;
}
#CombifyInput-dob-month {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
}
#CombifyInput-dob-month1 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
#CombifyInput-dob-month2 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
.ui-combobox {
    margin-right: 5px;
}
a.logo img {
    max-width: 100% !important;
    padding: 6px;
    width: 350px;
}
p.date div {
    float: left;
}
#CombifyInput-dob-day {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
}
#CombifyInput-dob-day1 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
#CombifyInput-dob-day2 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
#CombifyInput-dob-year {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
}
#CombifyInput-dob-year1 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
#CombifyInput-dob-year2 {
    padding-top: 0;
    width: 75px;
    border: 0;
    font-size: 16px !important;
    padding: 2px 1px 2px 2px;
    height: 20px;
}
.date-box {
    display: block;
    float: left;
    position: relative;
}
.date-box select {
    left: 0;
    overflow-y: scroll;
}
ul,
ol,
dl {
    padding: 0;
    margin: 0;
}
ul li {
    margin-left: 15px;
}
ul li li {
    list-style: disc outside none;
}

ul {
    margin-bottom: 2%;
}
a img {
    border: none;
}

.formBox a {
    color: #004961;
}
.floatlft {
    float: left;
    display: block;
    margin-bottom: 10px;
}
.hcp .button {
    background-color: #83156f;
    color: #fff;
    float: left;
    height: 60px;
    padding-left: 100px;
    padding-top: 20px;
    text-decoration: none;
    width: 290px;
}
.patients .button {
    color: #fff;
    float: left;
    height: 60px;
    padding-left: 80px;
    padding-top: 20px;
    text-decoration: none;
    width: 240px;
}
.content-buttons {
    margin: 0 auto;
    display: block;
}
.hcp .button.enroll {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: left;
    float: none;
    display: block;
    margin: 0 auto;
}
.hcp .button.account {
    /*background-image:url(../images/account.png);*/
    background-repeat: no-repeat;
    background-position: left;
    float: none;
    display: block;
    margin: 0 auto;
}
.content-buttons {
    width: 850px !important;
}
.patients .button.enroll {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: left;
    float: left;
    color: #83156f;
    border: 2px solid #83156f;
    text-transform: uppercase;
    font-family: "Avenir Next LT W01 Bold";
    border-radius: 10px;
    height: 60px;
    padding-left: 70px;
    padding-top: 15px;
    text-decoration: none;
    width: 240px;
    font-size: 21px;
}
.patients .button.account {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: left;
    float: right;
    color: #83156f;
    border: 2px solid #83156f;
    text-transform: uppercase;
    font-family: "Avenir Next LT W01 Bold";
    border-radius: 10px;
    height: 60px;
    padding-left: 70px;
    padding-top: 15px;
    text-decoration: none;
    width: 240px;
    font-size: 21px;
}

.strong {
    font-weight: 700;
}
/* footer always bottom */

#wrapper {
    /* min-height: 100%; */
    height: auto !important;
    height: 100%;
    margin: 0 auto 0;
}
#header {
    max-width: 100%;
    padding: 0;
    position: relative;
    white-space: nowrap;
    width: auto;
}
.nav > li > a {
    padding: 7px 8px !important;
}
.hcp .nav li,
.submenu .nav li {
}
.hcp .nav.user-area li {
    width: auto;
}
#container {
    position: relative;
    padding-bottom: 30px;
}
#mobile-menu {
    display: none;
}
.submenu {
    max-width: 100%;
}
.headerBackground {
    max-width: 956px;
    height: auto;
    width: 100%;
    position: relative;
    margin: 8px auto 0 auto;
    border: 3px solid #fff;
}
ul.nav,
.submenu ul.nav {
    display: block;
    height: 50px;
    margin: 0;
    padding: 0;
    list-style: none;
}
.nav {
    margin-left: 30px;
}
.subsubmenu {
    margin: 0 auto;
    width: 851px;
}
#home-container {
    background-color: #eee;
    padding: 20px;
    float: left;
    width: 100%;
    margin-bottom: 55px;
    margin-top: 40px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.submenu .nav {
    width: 851px;
}
#nav {
}
.nav li,
.submenu .nav li {
    float: left;
    margin: inherit;
    list-style: none;
    width: 212px;
    text-align: center;
}
#tabs .nav li {
    width: auto;
}
.hcp li {
    //width: 160px;
}
.nav li:first-child,
.submenu .nav li:first-child {
    border-left: none;
}

.nav a,
.submenu .nav a,
.responsive-button {
    display: inline-block;
    padding: 17px 15px 14px 15px;
    margin-right: 2px;
    margin-top: 4px;
    border: 1px solid #f2f2f2 !important;
    background-color: #f2f2f2;
    color: #83156f;
    text-decoration: none;
    font-family: "Avenir Next LT W01 Bold";
}

.patients .nav .selected a,
.submenu .nav .selected a,
.responsive-button.active {
    border: 1px solid #fff !important;
    color: #fff;
    text-decoration: none;
}
.hcp li.selected a {
    background-color: #83156f;
    color: #fff;
    text-decoration: none;
}
.hcp li.selected ul li a {
    background-color: #f2f2f2;
    text-decoration: none;
    color: #83156f;
}
.hcp li.selected a .arrow {
    border: solid #fff;
    border-width: 0 1px 1px 0;
}
.patients li.selected a {
    border: 1px solid #83156f !important;
    background-color: #83156f;
    color: #fff;
    text-decoration: none;
}
.patients li.selected ul li a {
    border: 0 !important;
    background-color: #f2f2f2;
    color: #83156f !important;
    text-decoration: none;
}
.patients li.selected ul li a:hover {
    color: #fff !important;
}
.patients li.selected a .arrow {
    border: solid #fff;
    border-width: 0 1px 1px 0;
}
.required {
    font-size: 13px;
}
.requiredField {
    margin-bottom: -10px;
    font-size: 12px;
    color: red;
}
.buttons_box {
    margin: 40px 0 40px 0;
}
.buttons_box2 {
    margin: 40px 0 40px 150px;
}
.buttons_box a,
.buttons_box2 a {
    display: block;
    float: left;
    font-size: 18px;
    color: #fff;
    width: 230px;
    height: 56px;
    text-decoration: none;
    vertical-align: middle;
    padding-right: 4px;
    padding-left: 30px;
    padding-top: 14px;
}
a.xolair_but {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
a.xolair_but-Y {
    /*background: url(../images/but_xolairY.jpg);*/
}
a.actemra_but {
    margin: 0 28px;
    /*background: url(../images/but_actemra.jpg);*/
}
a.hcp_but {
    /*background: url(../images/but_hcp.jpg);*/
}
td {
    border: 1px solid;
}
.callout {
    box-shadow: 5px 5px 2px rgba(43, 50, 50, 0.35);
    margin: 20px 50px 25px 40px;
    min-height: 84px;
    background: rgb(101, 5, 84); /* Old browsers */
    /* IE9 SVG, needs conditional override of 'filter' to 'none' */
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
    background: linear-gradient(to bottom, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#650554', endColorstr='#850d70', GradientType=0 ); /* IE6-8 */
    padding: 15px 19px;
    font: bold 14px/20px verdana, arial;
    color: #fff;
}
.callout p {
    margin-right: 100px;
}
.callout .bg {
    min-height: 84px;
    background: /*url(../images/ArrowImportNotice.png)*/ right center no-repeat;
}
.callout a {
    color: #f9f040;
}
.error {
    color: #ff0000;
    margin-bottom: 3px;
    font-weight: 100;
    display: block;
    float: left;
}
/* my */
.prompt-error.error {
    display: block;
    float: left;
    font-size: 13px;
}
table {
    margin: 45px 0;
}
td,
th {
    padding: 6px;
}
td {
    background: #f2f2f2;
    border: none;
}
th {
    text-align: left;
    background: #f2f2f2;
    color: #000;
}
.actemra th {
    background: #7ebe36;
}
label {
    width: 45%;
    float: left;
    text-align: right;
    margin-right: 6px;
}
label.regularLabel {
    width: 316px !important;
    float: left;
    text-align: right;
    margin-right: 6px;
}
label.larger {
    width: 600px;
}
input[type="text"],
input[type="password"] {
    isplay: block;
    border: 1px solid #ddd;
    padding: 12;
    border-radius: 5px;
}

.table-form label {
    float: none;
    width: auto;
    display: block;
}
table.table-form,
table.table-form td {
    border-collapse: collapse;
}
.table-form td {
    background: none;
    font-size: 14px;
}

input[type="submit"] {
    margin-left: 60%;
    font-family: CongressSansStd;
}
input[type="checkbox"] {
    margin-top: 4px;
}
input[type="checkbox"] {
    margin-top: 0px \\;;
}
input[type="radio"] {
    margin-top: 4px;
}
form p {
    clear: both;
    float: left;
    width: 100%;
}
.objcenter {
    text-align: center;
}
.objcenter img {
    text-align: center;
    display: inline-block;
}
.objcenter table {
    margin: 6px 45px;
    width: 761px;
}
.objcenter a {
    display: inline-block;
    float: left;
    background: #0967b4;
    width: 224px;
    height: 58px;
    padding: 6px;
    color: #fff;
    font-size: 22px;
    text-decoration: none;
    margin: 6px;
    border-radius: 5px;
    box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);
    -moz-box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);
    -webkit-box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);
}
.objcenter a:hover {
    background: #055190;
}
.boldred {
    font-weight: 100;
    color: red;
}
sup {
    line-height: 50%;
    vertical-align: middle;
}
.hideMess {
    display: none;
}
.endMatter {
    text-align: justify;
}
/* account */
#account_summary_box {
    border: 1px solid #ccc;
    margin: 20px 0;
    padding: 20px;
}
#account_summary_box li {
    list-style: none;
}
.avatar {
    float: left;
}
#account_details {
    float: left;
}

#container #account_details ul li {
    list-style: none;
}
.accountTable td {
    background: none;
}
.account th {
    text-align: center;
}
.accountTable img,
.accountTable input[type="text"] {
    display: inline;
}
.rght_al {
    text-align: right;
    padding-right: 80px;
}
.messagesTable {
    border: 1px solid #ccc;
    display: table !important;
}
.messagesTable th {
    text-align: center;
}
.wideForm label {
    width: 457px;
}
.wideForm input[type="submit"] {
    margin-left: 463px !important;
}
.vialNo a {
    display: block;
    margin-left: 258px;
}
a:hover.xolair_but,
a:hover.actemra_but,
a:hover.hcp_but {
    background-position: 0 -70px;
}
.formBox {
    margin: 30px 0px;
    /* pdf value: margin: 30px 50px;*/
}
.formboxbg {
    padding: 30px;
}
.formboxbg_big {
    padding: 30px;
    background-color: #fff;
}
.rtx_apply .formboxbg {
    padding: 30px;
    padding-right: 20px;
}
.formBox label {
    margin-bottom: 12px;
}
.rtx_pass-req label,
.rtx_pass-req_err label,
.rtx_apply-succ label,
.rtx_reg-succ label,
.act_pass-req label,
.act_pass-req_err label,
.act_apply-succ label,
.act_reg-succ label {
    width: 45%;
}
.rtx_pass-req input[type="submit"],
.rtx_pass-req_err input[type="submit"],
.rtx_apply-succ input[type="submit"],
.rtx_reg-succ input[type="submit"],
.act_pass-req input[type="submit"],
.act_pass-req_err input[type="submit"],
.act_apply-succ input[type="submit"],
.act_reg-succ input[type="submit"] {
    margin-left: 60%;
}
.rtx_reg .formBox,
.act_reg .formBox {
    margin: 30px 0;
    padding: 30px 15px;
}
.rtx_reg label,
.act_reg label {
    width: 677px;
}
.rtx_reg input[type="text"],
.act_reg input[type="text"] {
    width: 125px;
}
.act_reg input[type="text"] {
    width: 145px;
}
.act_reg label {
    width: 637px;
}
.rtx_reg input[type="submit"],
.act_reg input[type="submit"] {
    margin-left: 352px;
}
.rtx_reg_step2 label,
.act_reg_step2 label {
    width: 565px;
}
.act_reg_step2 label,
.rtx_reg_step2 label {
    width: 517px;
}
.rtx_reg_step2 input[type="submit"],
.act_reg_step2 input[type="submit"],
.rtx_notif input[type="submit"],
.act_notif input[type="submit"] {
    margin-left: 255px;
}
.act_notif label {
    width: 445px;
}
.rtx_notif label {
}
.hcp_prof label {
    width: 350px;
}
.hcp_prof input[type="submit"] {
    margin-left: 357px;
}
.rtx_verif-with label,
.rtx_verif-without label,
.act_verif-with label,
.act_verif-without label {
    width: 422px;
}
.rtx_verif-with input[type="submit"],
.rtx_verif-without input[type="submit"],
.act_verif-with input[type="submit"],
.act_verif-without input[type="submit"] {
    margin-left: 429px;
}
.select_container {
    border-radius: 4px;
    border: 1px solid #7d7f82;
    background: inherit;
    xfloat: left;
    padding: 2px 1px;
    display: inline-block;
}
select {
    border: 0;
    max-width: 190px;
    width: 190px;
}
#navsubmenu li a {
    font-size: 16px !important;
}
.ui-combobox {
    float: left;
    height: 21px;
    position: relative;
    width: 90px;
}
.hcp-popup {
    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);
    bottom: 0;
    display: none;
    left: 0;
    padding: 5%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}

.hcp-popup .popup-box {
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
    background: #fff;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
    margin: 0 auto;
    padding: 24px;
    width: 67%;
    overflow: auto;
}
.home-page-announcement {
    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);
    bottom: 0;

    left: 0;
    padding: 5%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}
.home-page-announcement .popup-box {
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
    background: #fff;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
    margin: 0 auto;
    padding: 24px;
    width: 67%;
    overflow: auto;
    margin-top: 3%;
}
.home-page-announcement .popup-box h1 {
    margin-top: 0;
}
.hcp-popup .popup-box button {
    margin-right: 7px;
}

.page-alert {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.page-alert .popup-box {
    /* padding: 20px;
    background: #fff;
    border-radius: 5px;
    margin: 0 auto;
    width: 62%;
    padding: 20px;
    position: relative;
    top: 200px;
    overflow: auto;

    height: 80vh;
    width: 80vw;
    max-height: 90vh; */

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    max-width: 90vw; /* Limit width to 90% of viewport width */
    max-height: 99vh;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    overflow: auto; /* Prevent scrolling */

    padding: 1em; /* Use em for padding */

    box-sizing: border-box;
}

.save-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.save-popup .popup-box {
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    margin: 0 auto;
    width: 700px;
    padding: 20px;
    position: relative;
    top: 200px;
}

.ok-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.ok-popup .popup-box {
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    margin: 0 auto;
    width: 600px;
    padding: 20px;
    position: relative;
    top: 200px;
}

.activate-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.activate-popup .popup-box {
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    margin: 0 auto;
    width: 600px;
    padding: 20px;
    position: relative;
    top: 200px;
}

.deactivate-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.deactivate-popup .popup-box {
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    margin: 0 auto;
    width: 600px;
    padding: 20px;
    position: relative;
    top: 200px;
}

.rejected-popup {
    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);
    bottom: 0;
    display: none;
    left: 0;
    padding: 5%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}

.rejected-popup .popup-box {
    background: none repeat scroll 0 0 #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    padding: 20px;
    width: 300px;
    overflow: auto;
    padding-bottom: 20px;
}
.rejected-popup .popup-box button {
    margin-bottom: 0px;
    margin-right: 0;
    float: right;
}
.rounded_container {
    border-radius: 4px;
    border: 1px solid #7d7f82;
    background: inherit;
    float: left;
    padding: 5px 10px;
    margin-bottom: 5px;
}
ul.tabs {
    border-bottom: 1px solid #555;
    height: 54px;
    margin: 15px 101px;
    /* pdf value: margin: 15px 67px;*/
    padding: 0;
}
ul.tabs li.margin-right-2 {
    margin-right: 2px;
}
ul.tabs li.active {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    background-color: #555;
    border-color: #555 #555 -moz-use-text-color;
    border-image: none;
    border-style: solid solid none;
    border-width: 1px 1px 0;
    color: #ffffff;
    display: block;
    float: left;
    font-size: 18px;
    height: 28px;
    outline: 0 none;
    padding: 12px 0px;
    position: relative;
    text-decoration: none;
    top: 1px;
}
ul.tabs li.inactive {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    background-color: #ccc;
    border-color: #555 #555 -moz-use-text-color;
    border-image: none;
    border-style: solid solid none;
    border-width: 1px 1px 0;
    color: #ffffff;
    display: block;
    float: left;
    font-size: 18px;
    height: 28px;
    outline: 0 none;
    padding: 12px 0px;
    position: relative;
    text-decoration: none;
    top: 1px;
}
ul.tabs li {
    float: left;
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 213px;
    text-align: center;
}
.disclaimer {
    margin-top: 25px;
}
.rghtAlig {
    margin-left: 431px;
}
.act_rghtAlig_stp3 {
    margin-left: 521px;
}
.checkSp {
    margin-left: 24px;
}
.checkSpsm {
    margin-left: 10px;
}
label.longLabel {
    width: 523px;
}
.footer_isi {
    padding-top: 20px;
}
#ui-datepicker-div {
    font-size: 10px;
}
.lft label {
    text-align: justify;
}
.rtx_apply .larger {
    padding-right: 14px;
}
.rtx_apply label.larger {
    max-width: 80%;
}
.rtx_apply .act_rghtAlig_stp3 {
    margin-left: 540px;
}
.rtx_apply input[type="radio"] {
    margin-top: 0;
}
.content-container {
    background: #f1f1f1;
    margin-left: 30px;
    margin-right: 30px;
    max-width: 100%;
    height: auto;
}
#container ul li {
    list-style: disc outside none;
    margin-left: 15px;
    margin-bottom: 7px;
}
#container ul li ul li {
    list-style: none;
}
#container ul li ul li:before {
    content: "-";
    position: relative;
    left: -15px;
}

#container ul.tabs li {
    list-style: disc outside none;
    margin-left: 0;
    padding-left: 0;
}
.centerTxt {
    text-align: center;
}
.centerTxt_top {
    text-align: center;
    vertical-align: top;
}
.centerTxt_top input[type="submit"] {
    margin-left: 0;
}
.centerTxt input {
    margin-left: 0;
    margin-right: 0;
}
.tdAlig {
    text-align: right;
    padding-right: 100px;
}
.buttons {
    display: none;
}
a.cta_box {
    background-size: 100% 100% !important;
    border: 4px solid #fff;
    padding: 15px;
    padding-right: 40px;
    color: #fff;
    position: relative;
    box-shadow: 0 1px 0 rgba(50, 50, 50, 0.33);
    font-size: 1.5em;
    text-shadow: 0 1px 0 #000000;
    line-height: 1.4em;
    margin: 14px 0;
    color: #ffffff !important;
    text-decoration: none;
    display: block;
}
a.gold {
    background: /*url(../images/cta_box.jpg) */ no-repeat left top transparent;
}
a.purple {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat left top transparent;
}
.cta_box p {
    max-width: 500px;
    margin: 0;
}
span.cta {
    border: 3px solid white !important;
    bottom: 13px;
    color: #ffffff !important;
    font-size: 16px;
    height: 13px;
    line-height: 1;
    margin: 0;
    padding: 6px !important;
    position: absolute;
    right: 13px;
    text-decoration: none !important;
    text-transform: uppercase;
    vertical-align: top;
    text-shadow: none;
    font-weight: normal;
}
.cta span {
    background: /*url("../images/arrow-link-right.png")*/ no-repeat 0 -1px transparent;
    background-size: 13px;
    display: inline-block;
    height: 13px;
    width: 13px;
}

section#isiSingle {
    display: none;
}

nav.footerLinks {
    background-color: #850d70;
    text-align: center;
    padding: 0 37px;
    color: white;
}

nav.footerLinks a {
    display: inline-block;
    margin: 10px 2px;
    padding: 5px 1px;
    font-size: 0.857em;
    whitespace: no-wrap;
}

nav.footerLinks a:link,
nav.footerLinks a:active,
nav.footerLinks a:visited {
    color: white;
    text-decoration: none;
    border-bottom: 1px dotted #fff;
    padding-bottom: 1px;
}
ul.nav_over_nav,
.nav_over_nav #submenuslider {
    margin-left: 230px;
}
ul.nav_over_nav li {
    margin-left: 0;
}
.media {
    padding: 0;
}
.submenu {
    padding-top: 0;
    padding-bottom: 0;
    width: inherit;
    padding-bottom: 15px;
}
.nowrapTxt {
    white-space: nowrap;
}
/* steps */
.three-step-container p,
.three-step-container h2 {
    padding: 0 25px;
}

.three-step-container p.error {
    color: #990000;
    display: none;
}

.three-step-container .step-container {
    margin: 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
}

.three-step-container .pill-button .icon {
    background: transparent /* url('../images/arrow_rt.png')*/ right center no-repeat;
    display: block;
    padding-right: 25px;
}

.step-locator {
    width: 100%;
    padding: 0;
    margin: 0;
    clear: both;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
}

.step1,
.step2,
.step3 {
    width: 32%;
    background: transparent /*url('../images/stepTab.png')*/ top right no-repeat;
    height: 31px;
    border-bottom: 1px solid #ccc;
    padding: 10px 0 20px 0;
    float: left;
}
.step3:last-child {
    width: 36%;
    background: transparent /* url('../images/stepTab3.png')*/ top center repeat-x;
}

.step1 span,
.step2 span,
.step3 span {
    color: #666;
    display: block;
    cursor: pointer;
    text-align: center;
    padding: 0 25px;
    font-size: 1.143em;
}
.step1 span.active,
.step2 span.active,
.step3 span.active {
    font-weight: bold;
    color: #333;
}

.step1 span .subhead,
.step2 span .subhead,
.step3 span .subhead {
    color: #666;
    display: block;
    font-size: 0.929em;
}
#header .responsive-button {
    cursor: pointer;
    margin-bottom: 20px;
}
.desktopcode {
    display: block;
}
.tabletcode {
    display: none;
}
.mobilecode {
    display: none;
}

@media only screen and (min-width: 681px) {
}
@media only screen and (max-width: 680px) {
    #header {
        height: auto;
        margin-bottom: 20px;
    }
    #header .responsive-button {
        display: block;
    }
    p.mobile-view {
        display: none;
    }
    ul.nav {
        height: auto;
        margin-bottom: 20px;
        display: none;
    }
    .nav li {
        display: block;
        float: none;
        margin-bottom: 10px;
    }
    .nav a {
        display: block;
        width: auto;
    }
}
@media only screen and (max-width: 767px) {
    .nav a,
    .submenu .nav a,
    .responsive-button {
        margin-right: 5px;
    }
}

@media only screen and (min-width: 200px) and (max-width: 479px) {
    .desktopcode {
        display: none;
    }
    .tabletcode {
        display: none;
    }
    .mobilecode {
        display: block;
    }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
    .desktopcode {
        display: none;
    }
    .tabletcode {
        display: none;
    }
    .mobilecode {
        display: block;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .desktopcode {
        display: none;
    }
    .tabletcode {
        display: block;
    }
    .mobilecode {
        display: none;
    }
}

@media only screen and (min-width: 680px) and (max-width: 768px) {
    p.mobile-view {
        display: none;
    }
}

@media only screen and (max-width: 660px) {
    body {
        margin-top: 0;
    }

    .content-container {
        margin: 0 25px;
    }
    #container {
        margin: 0;
        padding: 1px 10px 30px;
    }
    .formBox {
        margin: 0;
    }
    label {
        float: none;
    }
    .rtx_apply label.larger {
        width: 70%;
        float: left;
    }
    .three-step-container p.pad span {
        width: 80%;
    }
    .three-step-container .step-container {
        margin: 0;
    }
    .three-step-container p,
    .three-step-container h2 {
        padding: 0;
    }
    a.cta_box {
        font-size: 1em;
        padding: 15px 40px 50px 15px;
    }
}

@media only screen and (max-width: 900px) {
    .step1 span .subhead,
    .step2 span .subhead,
    .step3 span .subhead {
        font-size: 11px;
        padding: 0;
    }
}

.tabular-steps {
    padding: 5px;
    background: #fff;
}

.step-content {
    background: #fff;
}

.tabular-steps .step-content #step-one-content p {
    padding: 0 20px 0 45px;
}

.tabular-steps div.inputelement_wrap {
    position: relative;
    display: list-item;
}

.tabular-steps span.inputelement {
    display: block;
    width: 50%;
    position: relative;
}

.tabular-steps span.number_list {
    display: block;
    top: 40px;
    left: 24px;
    position: absolute;
}

.tabular-steps#step-two-content span.inputelement {
    width: auto;
    text-align: right;
}

.tabular-steps#step-two-content span.inputelement .whyAsk {
    position: relative;
    right: auto;
    top: 0;
    text-align: right;
}

.tabular-steps#step-two-content span.inputelement .whyAskAnswerStyles {
    left: auto;
    right: 0;
}

.tabular-steps .notvalid span.inputelement {
    background: transparent /* url('/images/dtc/act_error_alert.png')*/ 100% 25px no-repeat;
    background-size: 20px;
}

.tabular-steps span.inputelement span.stack {
    display: block;
    overflow: hidden;
}

.tabular-steps span.inputelement span.stack span.left {
    float: left;
    display: block;
    width: 50%;
}

.tabular-steps span.inputelement span.stack span.right {
    float: left;
    display: block;
    margin-left: 4%;
    width: 35%;
}

.tabular-steps span.inputelement .ui-selectmenu {
    width: 100% !important;
    height: 25px;
    font-size: 0.8em;
}

.tabular-steps label {
    display: block;
    margin-bottom: 5px;
}

.tabular-steps .notvalid label {
    color: #990000;
}

.tabular-steps span.inputelement input {
    width: 85%;
    border-radius: 5px;
    border: 1px solid #333;
    padding: 5px;
    outline: none;
}
.tabular-steps span.inputelement select {
    width: 55%;
    border-radius: 5px;
    border: 1px solid #333;
    outline: none;
}
.tabular-steps span.inputelement input.shortened {
    width: 85%;
}
.tabular-steps span.inputelement input.phonearea,
.tabular-steps span.inputelement input.phoneprefix,
.tabular-steps span.inputelement input.birthMonth,
.tabular-steps span.inputelement input.birthDay {
    width: 13%;
    margin-right: 4%;
}

.tabular-steps span.inputelement input.birthDay,
.tabular-steps span.inputelement input.phoneprefix {
    margin-left: 4%;
}

.tabular-steps span.inputelement input.phonesuffix,
.tabular-steps span.inputelement input.birthYear {
    margin-left: 4%;
    width: 30%;
}

.tabular-steps span.inputelement .ageWrong {
    display: none;
    margin-top: 10px;
    font-size: 0.85em;
    color: #990000;
}
.dotted {
    border-bottom: 1px dotted #cccccc;
}

form.form-validate p.field.hide {
    display: none;
}
form.form-validate div.hide {
    display: none;
}
.message-blob {
    display: none;
    width: 940px;
    position: fixed;
    top: 100px;
    left: 50%;
    margin-left: -480px;
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
}
.message-blob .close {
    position: absolute;
    right: -20px;
    top: -22px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
    width: 39px;
    height: 39px;
    cursor: pointer;
}
.message-blob iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
}
.rtx_apply p.pad label.larger {
    margin-left: 20px;
}
.three-step-container p.pad {
}
.rtx_apply p.pad input[type="radio"] {
    display: block;
    float: left;
    margin-top: 0;
    width: 2%;
}
.three-step-container p.pad span {
    display: block;
    float: left;
    width: 95%;
}
.apply-agreement {
    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);
    bottom: 0;
    display: none;
    left: 0;
    padding: 5%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;
}
.apply-agreement .popup-box {
    background: none repeat scroll 0 0 #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    padding: 10px;
    width: 600px;
}

.social-number-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.social-number-popup .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 20px;
    position: relative;
    height: 800px;
    overflow-y: scroll;
}
.social-number-popup .close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 16px;
}

.social-number-popup1 {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.social-number-popup1 .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 20px;
    position: relative;
    height: 800px;
    overflow-y: scroll;
}
.social-number-popup1 .close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 16px;
}

.social-number-popup2 {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.social-number-popup2 .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 20px;
    position: relative;
    height: 800px;
    overflow-y: scroll;
}
.social-number-popup2 .close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 16px;
}

.social-number-popup3 {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.social-number-popup3 .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 20px;
    position: relative;
    height: 800px;
    overflow-y: scroll;
}
.social-number-popup3 .close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 16px;
}

.holidays-popup {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: rgba(10, 10, 10, 0.3);
    z-index: 100;
}
.holidays-popup .popup-box {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px 5px #555;
    margin: 0 auto;
    width: 800px;
    padding: 15px;
    position: relative;
    margin-top: 70px;
}
.holidays-popup .close-button {
    font-size: 16px;
}
.holidays-popup ul {
    margin-left: 20px;
}

.field.social-security-number-dontwantto {
    display: none;
}

/* tables */
table.tablesorter th {
    font-weight: 400;
    text-align: center;
}

table.tablesorter thead tr .header {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-position: center right;
    cursor: pointer;
    padding-right: 7px;
}
.hcp th {
    font-weight: normal;
}
table.tablesorter thead tr .headerSortUp {
    /*background-image: url(../images/asc.gif);*/
}
table.tablesorter thead tr .headerSortDown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

#onetrust-policy-text a {
    display: inline;
    color: #565656 !important;
}

@media only screen and (max-width: 420px) {
    .rtx_apply label.larger {
        width: 67%;
    }
    .small-s {
        display: none;
    }
}
@media only screen and (max-width: 660px) {
    .three-step-container p.pad span {
        width: 80%;
    }
}

@media (max-width: 1023px) and (min-width: 661px), (max-device-width: 1024px) and (min-device-width: 661px) and (orientation: portrait) {
    .three-step-container p.pad span {
        width: 90%;
    }
    #container {
        max-width: 100%;
        width: 100%;
        margin: 0;
    }
    #wrapper-inner {
        width: 100%;
    }
}
/* my */

@media only screen and (max-width: 840px) {
    .apply-agreement .popup-box {
        border-radius: 0;
        width: 80%;
        height: 80%;
        padding: 5%;
        overflow: scroll;
    }
    .apply-agreement .popup-box button {
        margin-bottom: 20px;
    }

    .social-number-popup .popup-box {
        width: auto;
    }
}

@media only screen and (max-width: 740px) {
    .apply-step-two-form .social-security-number-field label {
        min-height: 50px;
    }
    .apply-step-two-form .field .social-number-need {
        display: block;
    }
}

@media only screen and (max-width: 670px) {
    .tabular-steps label {
        width: auto;
        margin-bottom: 0;
        text-align: left;
    }
    .tabular-steps .field {
        margin-bottom: 20px;
    }
    .apply-step-two-form .social-security-number-field label {
        height: auto;
        min-height: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,8BAA8B;IAC9B,uCAAuC;IACvC;6DACyD;IACzD,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;AACA;AACA;IACI,aAAa;AACjB;AACA,YAAY;AACZ;IACI,WAAW;IACX,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,OAAO;IACP,kBAAkB;AACtB;AACA;;;IAGI,UAAU;IACV,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,yDAA2C;IAC3C,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,cAAc;AAClB;AACA;IACI,+CAA+C;IAC/C,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,cAAc;AAClB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yDAAoD;IACpD,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,yDAAqD;IACrD,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA,yBAAyB;;AAEzB;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,2BAA2B;AAC/B;AACA;;AAEA;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;IAEI,cAAc;IACd,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gHAAgH;AACpH;AACA;IACI,YAAY;AAChB;AACA;AACA;AACA;;IAEI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;;IAEI,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;;;IAGI,iCAAiC;IACjC,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,UAAU;AACd;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,cAAc;IACd,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,mDAAyC;AAC7C;AACA;IACI,8CAA8C;AAClD;AACA;IACI,cAAc;IACd,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,iBAAiB;AACrB;AACA;IAGI,8CAA8C;IAC9C,2BAA2B;IAC3B,gBAAgB;IAChB,2BAA2B,EAAE,iBAAiB;IAC9C,8DAA8D;IAC9D,mDAAmqB,EACxkB,WAAW,EAOnG,oBAAoB,EACuE,yBAAyB,EAC9B,iBAAiB,EAChB,UAAU;IACpG,0FAA0F,EAAE,QAAQ;IACpG,oHAAoH,EAAE,UAAU;IAChI,kBAAkB;IAClB,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,2EAA2E;AAC/E;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;AACA,OAAO;AACP;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,sBAAsB;IACtB,WAAW;IAEX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,WAAW;IAEX,kBAAkB;IAClB,2CAA2C;IAC3C,gDAAgD;IAChD,mDAAmD;AACvD;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA,YAAY;AACZ;IACI,sBAAsB;IACtB,cAAc;IACd,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;;;IAGI,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;;;;;;;;IAQI,UAAU;AACd;AACA;;;;;;;;IAQI,gBAAgB;AACpB;AACA;;IAEI,cAAc;IACd,kBAAkB;AACtB;AACA;;IAEI,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;AACA;;;;IAII,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;AACA;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;;;;IAII,YAAY;AAChB;AACA;;;;IAII,kBAAkB;AACtB;AACA;IAGI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,wDAAwD;IACxD,SAAS;IACT,aAAa;IACb,OAAO;IACP,WAAW;IACX,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,wHAAwH;IACxH,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,UAAU;IACV,cAAc;AAClB;AACA;IACI,wDAAwD;IACxD,SAAS;;IAET,OAAO;IACP,WAAW;IACX,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;AACA;IACI,wHAAwH;IACxH,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,UAAU;IACV,cAAc;IACd,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI;;;;;;;;;;;;uBAYmB;;IAEnB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,eAAe,EAAE,yCAAyC;IAC1D,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;IACb,cAAc,EAAE,sBAAsB;;IAEtC,YAAY,EAAE,uBAAuB;;IAErC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,wDAAwD;IACxD,SAAS;IACT,aAAa;IACb,OAAO;IACP,WAAW;IACX,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,uCAAuC;IACvC,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;AACA;IAGI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAGlB,0CAA0C;IAC1C,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,0EAA0E;AAC9E;AACA;IACI,kFAA4E;AAChF;AACA;IACI,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kFAAkF;IAClF,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA,UAAU;AACV;;IAEI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iFAAiF;IACjF,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;;IAGI,UAAU;IACV,4EAA4E;IAC5E,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,UAAU;IACV,8EAA8E;AAClF;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;;;IAGI,iBAAiB;IACjB,WAAW;AACf;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;AACA;AACA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,WAAW;IACf;AACJ;AACA;IACI;;;QAGI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,SAAS;IACb;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;;QAEI,UAAU;IACd;IACA;QACI,cAAc;QACd,4BAA4B;IAChC;AACJ;;AAEA;IACI;;;QAGI,eAAe;QACf,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,uFAAuF;IACvF,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;;;;IAII,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAG9B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,6DAA4D;IAC5D,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IAGZ,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;AACA;AACA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,SAAS;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,UAAU;AACd;AACA;IACI,wDAAwD;IACxD,SAAS;IACT,aAAa;IACb,OAAO;IACP,WAAW;IACX,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;AACA;IACI,uCAAuC;IACvC,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yDAAuC;IACvC,4BAA4B;IAC5B,iCAAiC;IACjC,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,yDAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,WAAW;QACX,SAAS;IACb;IACA;QACI,WAAW;IACf;AACJ;AACA,OAAO;;AAEP;IACI;QACI,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":["@charset \"utf-8\";\r\n@font-face {\r\n    font-family: \"CongressSansStd\";\r\n    /*src: url('../fonts/241041_B_0.eot');*/\r\n    src:/*url('../fonts/241041_B_0.eot?#iefix')*/ format(\"embedded-opentype\"), /*url('../fonts/241041_B_0.woff')*/ format(\"woff\"),\r\n        /*url('../fonts/241041_B_0.ttf')*/ format(\"truetype\");\r\n    font-weight: normal;\r\n    font-style: normal;\r\n}\r\n\r\nbody {\r\n}\r\n.file2 {\r\n    display: none;\r\n}\r\n/*all pages*/\r\n.clearfloat {\r\n    clear: both;\r\n    height: 0;\r\n    font-size: 1px;\r\n    line-height: 0px;\r\n}\r\n#CombifyInput-dob-month {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n}\r\n#CombifyInput-dob-month1 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n#CombifyInput-dob-month2 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n.ui-combobox {\r\n    margin-right: 5px;\r\n}\r\na.logo img {\r\n    max-width: 100% !important;\r\n    padding: 6px;\r\n    width: 350px;\r\n}\r\np.date div {\r\n    float: left;\r\n}\r\n#CombifyInput-dob-day {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n}\r\n#CombifyInput-dob-day1 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n#CombifyInput-dob-day2 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n#CombifyInput-dob-year {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n}\r\n#CombifyInput-dob-year1 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n#CombifyInput-dob-year2 {\r\n    padding-top: 0;\r\n    width: 75px;\r\n    border: 0;\r\n    font-size: 16px !important;\r\n    padding: 2px 1px 2px 2px;\r\n    height: 20px;\r\n}\r\n.date-box {\r\n    display: block;\r\n    float: left;\r\n    position: relative;\r\n}\r\n.date-box select {\r\n    left: 0;\r\n    overflow-y: scroll;\r\n}\r\nul,\r\nol,\r\ndl {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\nul li {\r\n    margin-left: 15px;\r\n}\r\nul li li {\r\n    list-style: disc outside none;\r\n}\r\n\r\nul {\r\n    margin-bottom: 2%;\r\n}\r\na img {\r\n    border: none;\r\n}\r\n\r\n.formBox a {\r\n    color: #004961;\r\n}\r\n.floatlft {\r\n    float: left;\r\n    display: block;\r\n    margin-bottom: 10px;\r\n}\r\n.hcp .button {\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    float: left;\r\n    height: 60px;\r\n    padding-left: 100px;\r\n    padding-top: 20px;\r\n    text-decoration: none;\r\n    width: 290px;\r\n}\r\n.patients .button {\r\n    color: #fff;\r\n    float: left;\r\n    height: 60px;\r\n    padding-left: 80px;\r\n    padding-top: 20px;\r\n    text-decoration: none;\r\n    width: 240px;\r\n}\r\n.content-buttons {\r\n    margin: 0 auto;\r\n    display: block;\r\n}\r\n.hcp .button.enroll {\r\n    background-image: url(../images/enroll.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    float: none;\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n.hcp .button.account {\r\n    /*background-image:url(../images/account.png);*/\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    float: none;\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n.content-buttons {\r\n    width: 850px !important;\r\n}\r\n.patients .button.enroll {\r\n    background-image: url(../images/enroll-patients.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    float: left;\r\n    color: #83156f;\r\n    border: 2px solid #83156f;\r\n    text-transform: uppercase;\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n    border-radius: 10px;\r\n    height: 60px;\r\n    padding-left: 70px;\r\n    padding-top: 15px;\r\n    text-decoration: none;\r\n    width: 240px;\r\n    font-size: 21px;\r\n}\r\n.patients .button.account {\r\n    background-image: url(../images/account-patients.png);\r\n    background-repeat: no-repeat;\r\n    background-position: left;\r\n    float: right;\r\n    color: #83156f;\r\n    border: 2px solid #83156f;\r\n    text-transform: uppercase;\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n    border-radius: 10px;\r\n    height: 60px;\r\n    padding-left: 70px;\r\n    padding-top: 15px;\r\n    text-decoration: none;\r\n    width: 240px;\r\n    font-size: 21px;\r\n}\r\n\r\n.strong {\r\n    font-weight: 700;\r\n}\r\n/* footer always bottom */\r\n\r\n#wrapper {\r\n    /* min-height: 100%; */\r\n    height: auto !important;\r\n    height: 100%;\r\n    margin: 0 auto 0;\r\n}\r\n#header {\r\n    max-width: 100%;\r\n    padding: 0;\r\n    position: relative;\r\n    white-space: nowrap;\r\n    width: auto;\r\n}\r\n.nav > li > a {\r\n    padding: 7px 8px !important;\r\n}\r\n.hcp .nav li,\r\n.submenu .nav li {\r\n}\r\n.hcp .nav.user-area li {\r\n    width: auto;\r\n}\r\n#container {\r\n    position: relative;\r\n    padding-bottom: 30px;\r\n}\r\n#mobile-menu {\r\n    display: none;\r\n}\r\n.submenu {\r\n    max-width: 100%;\r\n}\r\n.headerBackground {\r\n    max-width: 956px;\r\n    height: auto;\r\n    width: 100%;\r\n    position: relative;\r\n    margin: 8px auto 0 auto;\r\n    border: 3px solid #fff;\r\n}\r\nul.nav,\r\n.submenu ul.nav {\r\n    display: block;\r\n    height: 50px;\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n.nav {\r\n    margin-left: 30px;\r\n}\r\n.subsubmenu {\r\n    margin: 0 auto;\r\n    width: 851px;\r\n}\r\n#home-container {\r\n    background-color: #eee;\r\n    padding: 20px;\r\n    float: left;\r\n    width: 100%;\r\n    margin-bottom: 55px;\r\n    margin-top: 40px;\r\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);\r\n}\r\n.submenu .nav {\r\n    width: 851px;\r\n}\r\n#nav {\r\n}\r\n.nav li,\r\n.submenu .nav li {\r\n    float: left;\r\n    margin: inherit;\r\n    list-style: none;\r\n    width: 212px;\r\n    text-align: center;\r\n}\r\n#tabs .nav li {\r\n    width: auto;\r\n}\r\n.hcp li {\r\n    //width: 160px;\r\n}\r\n.nav li:first-child,\r\n.submenu .nav li:first-child {\r\n    border-left: none;\r\n}\r\n\r\n.nav a,\r\n.submenu .nav a,\r\n.responsive-button {\r\n    display: inline-block;\r\n    padding: 17px 15px 14px 15px;\r\n    margin-right: 2px;\r\n    margin-top: 4px;\r\n    border: 1px solid #f2f2f2 !important;\r\n    background-color: #f2f2f2;\r\n    color: #83156f;\r\n    text-decoration: none;\r\n    font-family: \"Avenir Next LT W01 Bold\";\r\n}\r\n\r\n.patients .nav .selected a,\r\n.submenu .nav .selected a,\r\n.responsive-button.active {\r\n    border: 1px solid #fff !important;\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.hcp li.selected a {\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.hcp li.selected ul li a {\r\n    background-color: #f2f2f2;\r\n    text-decoration: none;\r\n    color: #83156f;\r\n}\r\n.hcp li.selected a .arrow {\r\n    border: solid #fff;\r\n    border-width: 0 1px 1px 0;\r\n}\r\n.patients li.selected a {\r\n    border: 1px solid #83156f !important;\r\n    background-color: #83156f;\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.patients li.selected ul li a {\r\n    border: 0 !important;\r\n    background-color: #f2f2f2;\r\n    color: #83156f !important;\r\n    text-decoration: none;\r\n}\r\n.patients li.selected ul li a:hover {\r\n    color: #fff !important;\r\n}\r\n.patients li.selected a .arrow {\r\n    border: solid #fff;\r\n    border-width: 0 1px 1px 0;\r\n}\r\n.required {\r\n    font-size: 13px;\r\n}\r\n.requiredField {\r\n    margin-bottom: -10px;\r\n    font-size: 12px;\r\n    color: red;\r\n}\r\n.buttons_box {\r\n    margin: 40px 0 40px 0;\r\n}\r\n.buttons_box2 {\r\n    margin: 40px 0 40px 150px;\r\n}\r\n.buttons_box a,\r\n.buttons_box2 a {\r\n    display: block;\r\n    float: left;\r\n    font-size: 18px;\r\n    color: #fff;\r\n    width: 230px;\r\n    height: 56px;\r\n    text-decoration: none;\r\n    vertical-align: middle;\r\n    padding-right: 4px;\r\n    padding-left: 30px;\r\n    padding-top: 14px;\r\n}\r\na.xolair_but {\r\n    background: url(../images/but_xolair.jpg);\r\n}\r\na.xolair_but-Y {\r\n    /*background: url(../images/but_xolairY.jpg);*/\r\n}\r\na.actemra_but {\r\n    margin: 0 28px;\r\n    /*background: url(../images/but_actemra.jpg);*/\r\n}\r\na.hcp_but {\r\n    /*background: url(../images/but_hcp.jpg);*/\r\n}\r\ntd {\r\n    border: 1px solid;\r\n}\r\n.callout {\r\n    -webkit-box-shadow: 5px 5px 2px rgba(43, 50, 50, 0.35);\r\n    -moz-box-shadow: 5px 5px 2px rgba(43, 50, 50, 0.35);\r\n    box-shadow: 5px 5px 2px rgba(43, 50, 50, 0.35);\r\n    margin: 20px 50px 25px 40px;\r\n    min-height: 84px;\r\n    background: rgb(101, 5, 84); /* Old browsers */\r\n    /* IE9 SVG, needs conditional override of 'filter' to 'none' */\r\n    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzY1MDU1NCIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiM4NTBkNzAiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);\r\n    background: -moz-linear-gradient(top, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* FF3.6+ */\r\n    background: -webkit-gradient(\r\n        linear,\r\n        left top,\r\n        left bottom,\r\n        color-stop(0%, rgba(101, 5, 84, 1)),\r\n        color-stop(100%, rgba(133, 13, 112, 1))\r\n    ); /* Chrome,Safari4+ */\r\n    background: -webkit-linear-gradient(top, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* Chrome10+,Safari5.1+ */\r\n    background: -o-linear-gradient(top, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* Opera 11.10+ */\r\n    background: -ms-linear-gradient(top, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* IE10+ */\r\n    background: linear-gradient(to bottom, rgba(101, 5, 84, 1) 0%, rgba(133, 13, 112, 1) 100%); /* W3C */\r\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#650554', endColorstr='#850d70', GradientType=0 ); /* IE6-8 */\r\n    padding: 15px 19px;\r\n    font: bold 14px/20px verdana, arial;\r\n    color: #fff;\r\n}\r\n.callout p {\r\n    margin-right: 100px;\r\n}\r\n.callout .bg {\r\n    min-height: 84px;\r\n    background: /*url(../images/ArrowImportNotice.png)*/ right center no-repeat;\r\n}\r\n.callout a {\r\n    color: #f9f040;\r\n}\r\n.error {\r\n    color: #ff0000;\r\n    margin-bottom: 3px;\r\n    font-weight: 100;\r\n    display: block;\r\n    float: left;\r\n}\r\n/* my */\r\n.prompt-error.error {\r\n    display: block;\r\n    float: left;\r\n    font-size: 13px;\r\n}\r\ntable {\r\n    margin: 45px 0;\r\n}\r\ntd,\r\nth {\r\n    padding: 6px;\r\n}\r\ntd {\r\n    background: #f2f2f2;\r\n    border: none;\r\n}\r\nth {\r\n    text-align: left;\r\n    background: #f2f2f2;\r\n    color: #000;\r\n}\r\n.actemra th {\r\n    background: #7ebe36;\r\n}\r\nlabel {\r\n    width: 45%;\r\n    float: left;\r\n    text-align: right;\r\n    margin-right: 6px;\r\n}\r\nlabel.regularLabel {\r\n    width: 316px !important;\r\n    float: left;\r\n    text-align: right;\r\n    margin-right: 6px;\r\n}\r\nlabel.larger {\r\n    width: 600px;\r\n}\r\ninput[type=\"text\"],\r\ninput[type=\"password\"] {\r\n    isplay: block;\r\n    border: 1px solid #ddd;\r\n    padding: 12;\r\n    -moz-border-radius: 5px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.table-form label {\r\n    float: none;\r\n    width: auto;\r\n    display: block;\r\n}\r\ntable.table-form,\r\ntable.table-form td {\r\n    border-collapse: collapse;\r\n}\r\n.table-form td {\r\n    background: none;\r\n    font-size: 14px;\r\n}\r\n\r\ninput[type=\"submit\"] {\r\n    margin-left: 60%;\r\n    font-family: CongressSansStd;\r\n}\r\ninput[type=\"checkbox\"] {\r\n    margin-top: 4px;\r\n}\r\ninput[type=\"checkbox\"] {\r\n    margin-top: 0px \\;;\r\n}\r\ninput[type=\"radio\"] {\r\n    margin-top: 4px;\r\n}\r\nform p {\r\n    clear: both;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.objcenter {\r\n    text-align: center;\r\n}\r\n.objcenter img {\r\n    text-align: center;\r\n    display: inline-block;\r\n}\r\n.objcenter table {\r\n    margin: 6px 45px;\r\n    width: 761px;\r\n}\r\n.objcenter a {\r\n    display: inline-block;\r\n    float: left;\r\n    background: #0967b4;\r\n    width: 224px;\r\n    height: 58px;\r\n    padding: 6px;\r\n    color: #fff;\r\n    font-size: 22px;\r\n    text-decoration: none;\r\n    margin: 6px;\r\n    -moz-border-radius: 5px;\r\n    border-radius: 5px;\r\n    box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);\r\n    -moz-box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);\r\n    -webkit-box-shadow: 4px 6px 17px rgba(0, 0, 0, 0.6);\r\n}\r\n.objcenter a:hover {\r\n    background: #055190;\r\n}\r\n.boldred {\r\n    font-weight: 100;\r\n    color: red;\r\n}\r\nsup {\r\n    line-height: 50%;\r\n    vertical-align: middle;\r\n}\r\n.hideMess {\r\n    display: none;\r\n}\r\n.endMatter {\r\n    text-align: justify;\r\n}\r\n/* account */\r\n#account_summary_box {\r\n    border: 1px solid #ccc;\r\n    margin: 20px 0;\r\n    padding: 20px;\r\n}\r\n#account_summary_box li {\r\n    list-style: none;\r\n}\r\n.avatar {\r\n    float: left;\r\n}\r\n#account_details {\r\n    float: left;\r\n}\r\n\r\n#container #account_details ul li {\r\n    list-style: none;\r\n}\r\n.accountTable td {\r\n    background: none;\r\n}\r\n.account th {\r\n    text-align: center;\r\n}\r\n.accountTable img,\r\n.accountTable input[type=\"text\"] {\r\n    display: inline;\r\n}\r\n.rght_al {\r\n    text-align: right;\r\n    padding-right: 80px;\r\n}\r\n.messagesTable {\r\n    border: 1px solid #ccc;\r\n    display: table !important;\r\n}\r\n.messagesTable th {\r\n    text-align: center;\r\n}\r\n.wideForm label {\r\n    width: 457px;\r\n}\r\n.wideForm input[type=\"submit\"] {\r\n    margin-left: 463px !important;\r\n}\r\n.vialNo a {\r\n    display: block;\r\n    margin-left: 258px;\r\n}\r\na:hover.xolair_but,\r\na:hover.actemra_but,\r\na:hover.hcp_but {\r\n    background-position: 0 -70px;\r\n}\r\n.formBox {\r\n    margin: 30px 0px;\r\n    /* pdf value: margin: 30px 50px;*/\r\n}\r\n.formboxbg {\r\n    padding: 30px;\r\n}\r\n.formboxbg_big {\r\n    padding: 30px;\r\n    background-color: #fff;\r\n}\r\n.rtx_apply .formboxbg {\r\n    padding: 30px;\r\n    padding-right: 20px;\r\n}\r\n.formBox label {\r\n    margin-bottom: 12px;\r\n}\r\n.rtx_pass-req label,\r\n.rtx_pass-req_err label,\r\n.rtx_apply-succ label,\r\n.rtx_reg-succ label,\r\n.act_pass-req label,\r\n.act_pass-req_err label,\r\n.act_apply-succ label,\r\n.act_reg-succ label {\r\n    width: 45%;\r\n}\r\n.rtx_pass-req input[type=\"submit\"],\r\n.rtx_pass-req_err input[type=\"submit\"],\r\n.rtx_apply-succ input[type=\"submit\"],\r\n.rtx_reg-succ input[type=\"submit\"],\r\n.act_pass-req input[type=\"submit\"],\r\n.act_pass-req_err input[type=\"submit\"],\r\n.act_apply-succ input[type=\"submit\"],\r\n.act_reg-succ input[type=\"submit\"] {\r\n    margin-left: 60%;\r\n}\r\n.rtx_reg .formBox,\r\n.act_reg .formBox {\r\n    margin: 30px 0;\r\n    padding: 30px 15px;\r\n}\r\n.rtx_reg label,\r\n.act_reg label {\r\n    width: 677px;\r\n}\r\n.rtx_reg input[type=\"text\"],\r\n.act_reg input[type=\"text\"] {\r\n    width: 125px;\r\n}\r\n.act_reg input[type=\"text\"] {\r\n    width: 145px;\r\n}\r\n.act_reg label {\r\n    width: 637px;\r\n}\r\n.rtx_reg input[type=\"submit\"],\r\n.act_reg input[type=\"submit\"] {\r\n    margin-left: 352px;\r\n}\r\n.rtx_reg_step2 label,\r\n.act_reg_step2 label {\r\n    width: 565px;\r\n}\r\n.act_reg_step2 label,\r\n.rtx_reg_step2 label {\r\n    width: 517px;\r\n}\r\n.rtx_reg_step2 input[type=\"submit\"],\r\n.act_reg_step2 input[type=\"submit\"],\r\n.rtx_notif input[type=\"submit\"],\r\n.act_notif input[type=\"submit\"] {\r\n    margin-left: 255px;\r\n}\r\n.act_notif label {\r\n    width: 445px;\r\n}\r\n.rtx_notif label {\r\n}\r\n.hcp_prof label {\r\n    width: 350px;\r\n}\r\n.hcp_prof input[type=\"submit\"] {\r\n    margin-left: 357px;\r\n}\r\n.rtx_verif-with label,\r\n.rtx_verif-without label,\r\n.act_verif-with label,\r\n.act_verif-without label {\r\n    width: 422px;\r\n}\r\n.rtx_verif-with input[type=\"submit\"],\r\n.rtx_verif-without input[type=\"submit\"],\r\n.act_verif-with input[type=\"submit\"],\r\n.act_verif-without input[type=\"submit\"] {\r\n    margin-left: 429px;\r\n}\r\n.select_container {\r\n    -webkit-border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    border-radius: 4px;\r\n    border: 1px solid #7d7f82;\r\n    background: inherit;\r\n    xfloat: left;\r\n    padding: 2px 1px;\r\n    display: inline-block;\r\n}\r\nselect {\r\n    border: 0;\r\n    max-width: 190px;\r\n    width: 190px;\r\n}\r\n#navsubmenu li a {\r\n    font-size: 16px !important;\r\n}\r\n.ui-combobox {\r\n    float: left;\r\n    height: 21px;\r\n    position: relative;\r\n    width: 90px;\r\n}\r\n.hcp-popup {\r\n    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);\r\n    bottom: 0;\r\n    display: none;\r\n    left: 0;\r\n    padding: 5%;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n}\r\n\r\n.hcp-popup .popup-box {\r\n    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);\r\n    background: #fff;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    border-radius: 4px;\r\n    margin: 0 auto;\r\n    padding: 24px;\r\n    width: 67%;\r\n    overflow: auto;\r\n}\r\n.home-page-announcement {\r\n    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);\r\n    bottom: 0;\r\n\r\n    left: 0;\r\n    padding: 5%;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n}\r\n.home-page-announcement .popup-box {\r\n    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);\r\n    background: #fff;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    border-radius: 4px;\r\n    margin: 0 auto;\r\n    padding: 24px;\r\n    width: 67%;\r\n    overflow: auto;\r\n    margin-top: 3%;\r\n}\r\n.home-page-announcement .popup-box h1 {\r\n    margin-top: 0;\r\n}\r\n.hcp-popup .popup-box button {\r\n    margin-right: 7px;\r\n}\r\n\r\n.page-alert {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.page-alert .popup-box {\r\n    /* padding: 20px;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin: 0 auto;\r\n    width: 62%;\r\n    padding: 20px;\r\n    position: relative;\r\n    top: 200px;\r\n    overflow: auto;\r\n\r\n    height: 80vh;\r\n    width: 80vw;\r\n    max-height: 90vh; */\r\n\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n\r\n    max-width: 90vw; /* Limit width to 90% of viewport width */\r\n    max-height: 99vh;\r\n    background-color: white;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    z-index: 1000;\r\n    overflow: auto; /* Prevent scrolling */\r\n\r\n    padding: 1em; /* Use em for padding */\r\n\r\n    box-sizing: border-box;\r\n}\r\n\r\n.save-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.save-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin: 0 auto;\r\n    width: 700px;\r\n    padding: 20px;\r\n    position: relative;\r\n    top: 200px;\r\n}\r\n\r\n.ok-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.ok-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin: 0 auto;\r\n    width: 600px;\r\n    padding: 20px;\r\n    position: relative;\r\n    top: 200px;\r\n}\r\n\r\n.activate-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.activate-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin: 0 auto;\r\n    width: 600px;\r\n    padding: 20px;\r\n    position: relative;\r\n    top: 200px;\r\n}\r\n\r\n.deactivate-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.deactivate-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    margin: 0 auto;\r\n    width: 600px;\r\n    padding: 20px;\r\n    position: relative;\r\n    top: 200px;\r\n}\r\n\r\n.rejected-popup {\r\n    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);\r\n    bottom: 0;\r\n    display: none;\r\n    left: 0;\r\n    padding: 5%;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n}\r\n\r\n.rejected-popup .popup-box {\r\n    background: none repeat scroll 0 0 #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    width: 300px;\r\n    overflow: auto;\r\n    padding-bottom: 20px;\r\n}\r\n.rejected-popup .popup-box button {\r\n    margin-bottom: 0px;\r\n    margin-right: 0;\r\n    float: right;\r\n}\r\n.rounded_container {\r\n    -webkit-border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    border-radius: 4px;\r\n    border: 1px solid #7d7f82;\r\n    background: inherit;\r\n    float: left;\r\n    padding: 5px 10px;\r\n    margin-bottom: 5px;\r\n}\r\nul.tabs {\r\n    border-bottom: 1px solid #555;\r\n    height: 54px;\r\n    margin: 15px 101px;\r\n    /* pdf value: margin: 15px 67px;*/\r\n    padding: 0;\r\n}\r\nul.tabs li.margin-right-2 {\r\n    margin-right: 2px;\r\n}\r\nul.tabs li.active {\r\n    -moz-border-bottom-colors: none;\r\n    -moz-border-left-colors: none;\r\n    -moz-border-right-colors: none;\r\n    -moz-border-top-colors: none;\r\n    background-color: #555;\r\n    border-color: #555 #555 -moz-use-text-color;\r\n    border-image: none;\r\n    border-style: solid solid none;\r\n    border-width: 1px 1px 0;\r\n    color: #ffffff;\r\n    display: block;\r\n    float: left;\r\n    font-size: 18px;\r\n    height: 28px;\r\n    outline: 0 none;\r\n    padding: 12px 0px;\r\n    position: relative;\r\n    text-decoration: none;\r\n    top: 1px;\r\n}\r\nul.tabs li.inactive {\r\n    -moz-border-bottom-colors: none;\r\n    -moz-border-left-colors: none;\r\n    -moz-border-right-colors: none;\r\n    -moz-border-top-colors: none;\r\n    background-color: #ccc;\r\n    border-color: #555 #555 -moz-use-text-color;\r\n    border-image: none;\r\n    border-style: solid solid none;\r\n    border-width: 1px 1px 0;\r\n    color: #ffffff;\r\n    display: block;\r\n    float: left;\r\n    font-size: 18px;\r\n    height: 28px;\r\n    outline: 0 none;\r\n    padding: 12px 0px;\r\n    position: relative;\r\n    text-decoration: none;\r\n    top: 1px;\r\n}\r\nul.tabs li {\r\n    float: left;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 213px;\r\n    text-align: center;\r\n}\r\n.disclaimer {\r\n    margin-top: 25px;\r\n}\r\n.rghtAlig {\r\n    margin-left: 431px;\r\n}\r\n.act_rghtAlig_stp3 {\r\n    margin-left: 521px;\r\n}\r\n.checkSp {\r\n    margin-left: 24px;\r\n}\r\n.checkSpsm {\r\n    margin-left: 10px;\r\n}\r\nlabel.longLabel {\r\n    width: 523px;\r\n}\r\n.footer_isi {\r\n    padding-top: 20px;\r\n}\r\n#ui-datepicker-div {\r\n    font-size: 10px;\r\n}\r\n.lft label {\r\n    text-align: justify;\r\n}\r\n.rtx_apply .larger {\r\n    padding-right: 14px;\r\n}\r\n.rtx_apply label.larger {\r\n    max-width: 80%;\r\n}\r\n.rtx_apply .act_rghtAlig_stp3 {\r\n    margin-left: 540px;\r\n}\r\n.rtx_apply input[type=\"radio\"] {\r\n    margin-top: 0;\r\n}\r\n.content-container {\r\n    background: #f1f1f1;\r\n    margin-left: 30px;\r\n    margin-right: 30px;\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n#container ul li {\r\n    list-style: disc outside none;\r\n    margin-left: 15px;\r\n    margin-bottom: 7px;\r\n}\r\n#container ul li ul li {\r\n    list-style: none;\r\n}\r\n#container ul li ul li:before {\r\n    content: \"-\";\r\n    position: relative;\r\n    left: -15px;\r\n}\r\n\r\n#container ul.tabs li {\r\n    list-style: disc outside none;\r\n    margin-left: 0;\r\n    padding-left: 0;\r\n}\r\n.centerTxt {\r\n    text-align: center;\r\n}\r\n.centerTxt_top {\r\n    text-align: center;\r\n    vertical-align: top;\r\n}\r\n.centerTxt_top input[type=\"submit\"] {\r\n    margin-left: 0;\r\n}\r\n.centerTxt input {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n}\r\n.tdAlig {\r\n    text-align: right;\r\n    padding-right: 100px;\r\n}\r\n.buttons {\r\n    display: none;\r\n}\r\na.cta_box {\r\n    background-size: 100% 100% !important;\r\n    border: 4px solid #fff;\r\n    padding: 15px;\r\n    padding-right: 40px;\r\n    color: #fff;\r\n    position: relative;\r\n    -webkit-box-shadow: 0 1px 0 rgba(50, 50, 50, 0.33);\r\n    -moz-box-shadow: 0 1px 0 rgba(50, 50, 50, 0.33);\r\n    box-shadow: 0 1px 0 rgba(50, 50, 50, 0.33);\r\n    font-size: 1.5em;\r\n    text-shadow: 0 1px 0 #000000;\r\n    line-height: 1.4em;\r\n    margin: 14px 0;\r\n    color: #ffffff !important;\r\n    text-decoration: none;\r\n    display: block;\r\n}\r\na.gold {\r\n    background: /*url(../images/cta_box.jpg) */ no-repeat left top transparent;\r\n}\r\na.purple {\r\n    background: url(../images/cta_box_purple.jpg) no-repeat left top transparent;\r\n}\r\n.cta_box p {\r\n    max-width: 500px;\r\n    margin: 0;\r\n}\r\nspan.cta {\r\n    border: 3px solid white !important;\r\n    bottom: 13px;\r\n    color: #ffffff !important;\r\n    font-size: 16px;\r\n    height: 13px;\r\n    line-height: 1;\r\n    margin: 0;\r\n    padding: 6px !important;\r\n    position: absolute;\r\n    right: 13px;\r\n    text-decoration: none !important;\r\n    text-transform: uppercase;\r\n    vertical-align: top;\r\n    text-shadow: none;\r\n    font-weight: normal;\r\n}\r\n.cta span {\r\n    background: /*url(\"../images/arrow-link-right.png\")*/ no-repeat 0 -1px transparent;\r\n    background-size: 13px;\r\n    display: inline-block;\r\n    height: 13px;\r\n    width: 13px;\r\n}\r\n\r\nsection#isiSingle {\r\n    display: none;\r\n}\r\n\r\nnav.footerLinks {\r\n    background-color: #850d70;\r\n    text-align: center;\r\n    padding: 0 37px;\r\n    color: white;\r\n}\r\n\r\nnav.footerLinks a {\r\n    display: inline-block;\r\n    margin: 10px 2px;\r\n    padding: 5px 1px;\r\n    font-size: 0.857em;\r\n    whitespace: no-wrap;\r\n}\r\n\r\nnav.footerLinks a:link,\r\nnav.footerLinks a:active,\r\nnav.footerLinks a:visited {\r\n    color: white;\r\n    text-decoration: none;\r\n    border-bottom: 1px dotted #fff;\r\n    padding-bottom: 1px;\r\n}\r\nul.nav_over_nav,\r\n.nav_over_nav #submenuslider {\r\n    margin-left: 230px;\r\n}\r\nul.nav_over_nav li {\r\n    margin-left: 0;\r\n}\r\n.media {\r\n    padding: 0;\r\n}\r\n.submenu {\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    width: inherit;\r\n    padding-bottom: 15px;\r\n}\r\n.nowrapTxt {\r\n    white-space: nowrap;\r\n}\r\n/* steps */\r\n.three-step-container p,\r\n.three-step-container h2 {\r\n    padding: 0 25px;\r\n}\r\n\r\n.three-step-container p.error {\r\n    color: #990000;\r\n    display: none;\r\n}\r\n\r\n.three-step-container .step-container {\r\n    margin: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n}\r\n\r\n.three-step-container .pill-button .icon {\r\n    background: transparent /* url('../images/arrow_rt.png')*/ right center no-repeat;\r\n    display: block;\r\n    padding-right: 25px;\r\n}\r\n\r\n.step-locator {\r\n    width: 100%;\r\n    padding: 0;\r\n    margin: 0;\r\n    clear: both;\r\n    border-bottom: 1px solid #ccc;\r\n    overflow: hidden;\r\n}\r\n\r\n.step1,\r\n.step2,\r\n.step3 {\r\n    width: 32%;\r\n    background: transparent /*url('../images/stepTab.png')*/ top right no-repeat;\r\n    height: 31px;\r\n    border-bottom: 1px solid #ccc;\r\n    padding: 10px 0 20px 0;\r\n    float: left;\r\n}\r\n.step3:last-child {\r\n    width: 36%;\r\n    background: transparent /* url('../images/stepTab3.png')*/ top center repeat-x;\r\n}\r\n\r\n.step1 span,\r\n.step2 span,\r\n.step3 span {\r\n    color: #666;\r\n    display: block;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    padding: 0 25px;\r\n    font-size: 1.143em;\r\n}\r\n.step1 span.active,\r\n.step2 span.active,\r\n.step3 span.active {\r\n    font-weight: bold;\r\n    color: #333;\r\n}\r\n\r\n.step1 span .subhead,\r\n.step2 span .subhead,\r\n.step3 span .subhead {\r\n    color: #666;\r\n    display: block;\r\n    font-size: 0.929em;\r\n}\r\n#header .responsive-button {\r\n    cursor: pointer;\r\n    margin-bottom: 20px;\r\n}\r\n.desktopcode {\r\n    display: block;\r\n}\r\n.tabletcode {\r\n    display: none;\r\n}\r\n.mobilecode {\r\n    display: none;\r\n}\r\n\r\n@media only screen and (min-width: 681px) {\r\n}\r\n@media only screen and (max-width: 680px) {\r\n    #header {\r\n        height: auto;\r\n        margin-bottom: 20px;\r\n    }\r\n    #header .responsive-button {\r\n        display: block;\r\n    }\r\n    p.mobile-view {\r\n        display: none;\r\n    }\r\n    ul.nav {\r\n        height: auto;\r\n        margin-bottom: 20px;\r\n        display: none;\r\n    }\r\n    .nav li {\r\n        display: block;\r\n        float: none;\r\n        margin-bottom: 10px;\r\n    }\r\n    .nav a {\r\n        display: block;\r\n        width: auto;\r\n    }\r\n}\r\n@media only screen and (max-width: 767px) {\r\n    .nav a,\r\n    .submenu .nav a,\r\n    .responsive-button {\r\n        margin-right: 5px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 200px) and (max-width: 479px) {\r\n    .desktopcode {\r\n        display: none;\r\n    }\r\n    .tabletcode {\r\n        display: none;\r\n    }\r\n    .mobilecode {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 480px) and (max-width: 767px) {\r\n    .desktopcode {\r\n        display: none;\r\n    }\r\n    .tabletcode {\r\n        display: none;\r\n    }\r\n    .mobilecode {\r\n        display: block;\r\n    }\r\n}\r\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\r\n    .desktopcode {\r\n        display: none;\r\n    }\r\n    .tabletcode {\r\n        display: block;\r\n    }\r\n    .mobilecode {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 680px) and (max-width: 768px) {\r\n    p.mobile-view {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 660px) {\r\n    body {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .content-container {\r\n        margin: 0 25px;\r\n    }\r\n    #container {\r\n        margin: 0;\r\n        padding: 1px 10px 30px;\r\n    }\r\n    .formBox {\r\n        margin: 0;\r\n    }\r\n    label {\r\n        float: none;\r\n    }\r\n    .rtx_apply label.larger {\r\n        width: 70%;\r\n        float: left;\r\n    }\r\n    .three-step-container p.pad span {\r\n        width: 80%;\r\n    }\r\n    .three-step-container .step-container {\r\n        margin: 0;\r\n    }\r\n    .three-step-container p,\r\n    .three-step-container h2 {\r\n        padding: 0;\r\n    }\r\n    a.cta_box {\r\n        font-size: 1em;\r\n        padding: 15px 40px 50px 15px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n    .step1 span .subhead,\r\n    .step2 span .subhead,\r\n    .step3 span .subhead {\r\n        font-size: 11px;\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n.tabular-steps {\r\n    padding: 5px;\r\n    background: #fff;\r\n}\r\n\r\n.step-content {\r\n    background: #fff;\r\n}\r\n\r\n.tabular-steps .step-content #step-one-content p {\r\n    padding: 0 20px 0 45px;\r\n}\r\n\r\n.tabular-steps div.inputelement_wrap {\r\n    position: relative;\r\n    display: list-item;\r\n}\r\n\r\n.tabular-steps span.inputelement {\r\n    display: block;\r\n    width: 50%;\r\n    position: relative;\r\n}\r\n\r\n.tabular-steps span.number_list {\r\n    display: block;\r\n    top: 40px;\r\n    left: 24px;\r\n    position: absolute;\r\n}\r\n\r\n.tabular-steps#step-two-content span.inputelement {\r\n    width: auto;\r\n    text-align: right;\r\n}\r\n\r\n.tabular-steps#step-two-content span.inputelement .whyAsk {\r\n    position: relative;\r\n    right: auto;\r\n    top: 0;\r\n    text-align: right;\r\n}\r\n\r\n.tabular-steps#step-two-content span.inputelement .whyAskAnswerStyles {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n\r\n.tabular-steps .notvalid span.inputelement {\r\n    background: transparent /* url('/images/dtc/act_error_alert.png')*/ 100% 25px no-repeat;\r\n    background-size: 20px;\r\n}\r\n\r\n.tabular-steps span.inputelement span.stack {\r\n    display: block;\r\n    overflow: hidden;\r\n}\r\n\r\n.tabular-steps span.inputelement span.stack span.left {\r\n    float: left;\r\n    display: block;\r\n    width: 50%;\r\n}\r\n\r\n.tabular-steps span.inputelement span.stack span.right {\r\n    float: left;\r\n    display: block;\r\n    margin-left: 4%;\r\n    width: 35%;\r\n}\r\n\r\n.tabular-steps span.inputelement .ui-selectmenu {\r\n    width: 100% !important;\r\n    height: 25px;\r\n    font-size: 0.8em;\r\n}\r\n\r\n.tabular-steps label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.tabular-steps .notvalid label {\r\n    color: #990000;\r\n}\r\n\r\n.tabular-steps span.inputelement input {\r\n    width: 85%;\r\n    border-radius: 5px;\r\n    border: 1px solid #333;\r\n    padding: 5px;\r\n    outline: none;\r\n}\r\n.tabular-steps span.inputelement select {\r\n    width: 55%;\r\n    border-radius: 5px;\r\n    border: 1px solid #333;\r\n    outline: none;\r\n}\r\n.tabular-steps span.inputelement input.shortened {\r\n    width: 85%;\r\n}\r\n.tabular-steps span.inputelement input.phonearea,\r\n.tabular-steps span.inputelement input.phoneprefix,\r\n.tabular-steps span.inputelement input.birthMonth,\r\n.tabular-steps span.inputelement input.birthDay {\r\n    width: 13%;\r\n    margin-right: 4%;\r\n}\r\n\r\n.tabular-steps span.inputelement input.birthDay,\r\n.tabular-steps span.inputelement input.phoneprefix {\r\n    margin-left: 4%;\r\n}\r\n\r\n.tabular-steps span.inputelement input.phonesuffix,\r\n.tabular-steps span.inputelement input.birthYear {\r\n    margin-left: 4%;\r\n    width: 30%;\r\n}\r\n\r\n.tabular-steps span.inputelement .ageWrong {\r\n    display: none;\r\n    margin-top: 10px;\r\n    font-size: 0.85em;\r\n    color: #990000;\r\n}\r\n.dotted {\r\n    border-bottom: 1px dotted #cccccc;\r\n}\r\n\r\nform.form-validate p.field.hide {\r\n    display: none;\r\n}\r\nform.form-validate div.hide {\r\n    display: none;\r\n}\r\n.message-blob {\r\n    display: none;\r\n    width: 940px;\r\n    position: fixed;\r\n    top: 100px;\r\n    left: 50%;\r\n    margin-left: -480px;\r\n    padding: 10px;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    -webkit-border-radius: 8px;\r\n    -moz-border-radius: 8px;\r\n    border-radius: 8px;\r\n}\r\n.message-blob .close {\r\n    position: absolute;\r\n    right: -20px;\r\n    top: -22px;\r\n    background: url(../images/messages-close-icon.png) no-repeat;\r\n    width: 39px;\r\n    height: 39px;\r\n    cursor: pointer;\r\n}\r\n.message-blob iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    -webkit-border-radius: 8px;\r\n    -moz-border-radius: 8px;\r\n    border-radius: 8px;\r\n}\r\n.rtx_apply p.pad label.larger {\r\n    margin-left: 20px;\r\n}\r\n.three-step-container p.pad {\r\n}\r\n.rtx_apply p.pad input[type=\"radio\"] {\r\n    display: block;\r\n    float: left;\r\n    margin-top: 0;\r\n    width: 2%;\r\n}\r\n.three-step-container p.pad span {\r\n    display: block;\r\n    float: left;\r\n    width: 95%;\r\n}\r\n.apply-agreement {\r\n    background: none repeat scroll 0 0 rgba(10, 10, 10, 0.3);\r\n    bottom: 0;\r\n    display: none;\r\n    left: 0;\r\n    padding: 5%;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 9999;\r\n}\r\n.apply-agreement .popup-box {\r\n    background: none repeat scroll 0 0 #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    width: 600px;\r\n}\r\n\r\n.social-number-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.social-number-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 20px;\r\n    position: relative;\r\n    height: 800px;\r\n    overflow-y: scroll;\r\n}\r\n.social-number-popup .close-button {\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 20px;\r\n    font-size: 16px;\r\n}\r\n\r\n.social-number-popup1 {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.social-number-popup1 .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 20px;\r\n    position: relative;\r\n    height: 800px;\r\n    overflow-y: scroll;\r\n}\r\n.social-number-popup1 .close-button {\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 20px;\r\n    font-size: 16px;\r\n}\r\n\r\n.social-number-popup2 {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.social-number-popup2 .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 20px;\r\n    position: relative;\r\n    height: 800px;\r\n    overflow-y: scroll;\r\n}\r\n.social-number-popup2 .close-button {\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 20px;\r\n    font-size: 16px;\r\n}\r\n\r\n.social-number-popup3 {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.social-number-popup3 .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 20px;\r\n    position: relative;\r\n    height: 800px;\r\n    overflow-y: scroll;\r\n}\r\n.social-number-popup3 .close-button {\r\n    position: absolute;\r\n    right: 30px;\r\n    top: 20px;\r\n    font-size: 16px;\r\n}\r\n\r\n.holidays-popup {\r\n    display: none;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: 10px;\r\n    background: rgba(10, 10, 10, 0.3);\r\n    z-index: 100;\r\n}\r\n.holidays-popup .popup-box {\r\n    padding: 20px;\r\n    background: #fff;\r\n    box-shadow: 0 0 5px 5px #555;\r\n    margin: 0 auto;\r\n    width: 800px;\r\n    padding: 15px;\r\n    position: relative;\r\n    margin-top: 70px;\r\n}\r\n.holidays-popup .close-button {\r\n    font-size: 16px;\r\n}\r\n.holidays-popup ul {\r\n    margin-left: 20px;\r\n}\r\n\r\n.field.social-security-number-dontwantto {\r\n    display: none;\r\n}\r\n\r\n/* tables */\r\ntable.tablesorter th {\r\n    font-weight: 400;\r\n    text-align: center;\r\n}\r\n\r\ntable.tablesorter thead tr .header {\r\n    background-image: url(../images/bg.gif);\r\n    background-repeat: no-repeat;\r\n    background-position: center right;\r\n    cursor: pointer;\r\n    padding-right: 7px;\r\n}\r\n.hcp th {\r\n    font-weight: normal;\r\n}\r\ntable.tablesorter thead tr .headerSortUp {\r\n    /*background-image: url(../images/asc.gif);*/\r\n}\r\ntable.tablesorter thead tr .headerSortDown {\r\n    background-image: url(../images/desc.gif);\r\n}\r\n\r\n#onetrust-policy-text a {\r\n    display: inline;\r\n    color: #565656 !important;\r\n}\r\n\r\n@media only screen and (max-width: 420px) {\r\n    .rtx_apply label.larger {\r\n        width: 67%;\r\n    }\r\n    .small-s {\r\n        display: none;\r\n    }\r\n}\r\n@media only screen and (max-width: 660px) {\r\n    .three-step-container p.pad span {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n@media (max-width: 1023px) and (min-width: 661px), (max-device-width: 1024px) and (min-device-width: 661px) and (orientation: portrait) {\r\n    .three-step-container p.pad span {\r\n        width: 90%;\r\n    }\r\n    #container {\r\n        max-width: 100%;\r\n        width: 100%;\r\n        margin: 0;\r\n    }\r\n    #wrapper-inner {\r\n        width: 100%;\r\n    }\r\n}\r\n/* my */\r\n\r\n@media only screen and (max-width: 840px) {\r\n    .apply-agreement .popup-box {\r\n        border-radius: 0;\r\n        width: 80%;\r\n        height: 80%;\r\n        padding: 5%;\r\n        overflow: scroll;\r\n    }\r\n    .apply-agreement .popup-box button {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .social-number-popup .popup-box {\r\n        width: auto;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 740px) {\r\n    .apply-step-two-form .social-security-number-field label {\r\n        min-height: 50px;\r\n    }\r\n    .apply-step-two-form .field .social-number-need {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 670px) {\r\n    .tabular-steps label {\r\n        width: auto;\r\n        margin-bottom: 0;\r\n        text-align: left;\r\n    }\r\n    .tabular-steps .field {\r\n        margin-bottom: 20px;\r\n    }\r\n    .apply-step-two-form .social-security-number-field label {\r\n        height: auto;\r\n        min-height: auto;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
